import {
  Box,
  CardMedia,
  Grid,
  List,
  ListItem,
  Typography,
} from "@mui/material";

import { features } from "@/utils/staticData/homeData";
import imageUrl from "@/assets/images/home/features.png";
import useResponsive from "@/hooks/useResponsive";

import ArrowRightIcon from "@/assets/icons/arrow-long-right.svg?react";
import ButtonWithIcon from "@/components/UI-Kit/ButtonWithIcon";
import CustomAccordion from "@/components/CustomAccordion";
import Section from "@/components/Section";
import { accordionStyles, listItemStyles, listStyles } from "./styles";

const MainFeatures = () => {
  const isDesktop = useResponsive("up", "md");
  return (
    <Section
      pt={{ xs: 5, md: 12.5, lg: 17.5 }}
      pb={{ xs: 5, md: 12.5, lg: 17.5 }}
    >
      <Typography variant="h2" color="text.primary" mb={{ xs: 5, md: 10 }}>
        Trackmate Features and Benefits
      </Typography>

      <Grid container columnSpacing={{ xs: 2, lg: 6, xl: 20 }}>
        <Grid item xs={12} md={6}>
          <Box
            display="flex"
            flexDirection="column"
            gap={{ xs: 2, md: 3 }}
            sx={accordionStyles}
          >
            {features.map(({ title, Icon, content, path }, index) => (
              <CustomAccordion
                key={index}
                label={title}
                icon={<Icon />}
                type="primary"
              >
                <Box maxWidth={520}>
                  <List disablePadding sx={listStyles}>
                    {content.map((item, index) => (
                      <ListItem disablePadding key={index} sx={listItemStyles}>
                        <Typography
                          variant="subtitle2"
                          component="p"
                          fontWeight={600}
                        >
                          {item}
                        </Typography>
                      </ListItem>
                    ))}
                  </List>
                  <ButtonWithIcon
                    label="Learn more"
                    IconComponent={ArrowRightIcon}
                    isLink={true}
                    to={path}
                  />
                </Box>
              </CustomAccordion>
            ))}
          </Box>
        </Grid>

        {isDesktop && (
          <Grid item xs={12} md={6}>
            <CardMedia
              component="img"
              loading="lazy"
              image={imageUrl}
              alt="image"
            />
          </Grid>
        )}
      </Grid>
    </Section>
  );
};

export default MainFeatures;
